import { twMerge } from "tailwind-merge";

interface TabsProps {
    list: React.ReactNode[];
    activeIdx: number;
    handleClick: (idx: number) => void;
}

export default function Tabs({ list, activeIdx, handleClick }: TabsProps) {
    const liStyle =
        "flex-1 text-[18px] text-[#999] font-[600] text-center py-[14px] px-[5px] bg-white rounded-t-[5px] cursor-pointer";
    const liOnStyle = twMerge(liStyle, "active !shadow-none bg-[#1D202B] text-white");

    return (
        <ul className="flex">
            {list.map((tab, i) => (
                <li
                    key={`tab_${i}`}
                    className={activeIdx === i ? liOnStyle : liStyle}
                    style={{ boxShadow: "inset 0px -4px 4px rgba(0, 0, 0, 0.04)" }}
                    onClick={() => handleClick(i)}
                >
                    {tab}
                </li>
            ))}
        </ul>
    );
}
